import { render } from "./ModalDoubles.vue?vue&type=template&id=69c919d7&scoped=true&ts=true&lang=pug"
import script from "./ModalDoubles.vue?vue&type=script&lang=ts"
export * from "./ModalDoubles.vue?vue&type=script&lang=ts"

import "./ModalDoubles.vue?vue&type=style&index=0&id=69c919d7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c919d7"]])

export default __exports__